import { Card, CardContent, CardHeader, CardTitle } from "@shared/ui/card";
import { useActivityLogs } from "../../hooks";
import { TIMELINE_LIMIT } from "@shared/utils/constants";

interface TimelineTabProps {
  remoteUtilityId: any;
  entityId?: string;
  keyCode?: string;
  actionType?: string;
  limit?: number;
  title?: string;
  subTitle?: string;
  icon?: React.ReactNode;
}

export function TimelineTab({
  remoteUtilityId,
  entityId,
  keyCode,
  actionType,
  limit,
}: TimelineTabProps) {
  const { activityLogs, isLoading } = useActivityLogs({
    entityId: entityId,
    keyCode: keyCode,
    remoteUtilityId: remoteUtilityId,
    actionType: actionType,
    limit: limit,
  });

  return (
    <Card>
      {limit !== TIMELINE_LIMIT && (
        <CardHeader>
          <CardTitle className="text-lg">Timeline</CardTitle>
        </CardHeader>
      )}
      <CardContent>
        {activityLogs?.results?.length === 0 ? (
          <div className="text-center p-8">
            <div className="h-10 w-10 text-gray-400 mx-auto mb-2 flex items-center justify-center">
              <svg
                className="h-8 w-8"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
            <h3 className="text-lg font-medium text-gray-600">
              No Timeline Events
            </h3>
            <p className="text-sm text-gray-500">
              No timeline events available for this request
            </p>
          </div>
        ) : (
          <div>
            {activityLogs?.results?.map((event, index) => (
              <div key={index} className="mb-6 flex gap-3">
                <div className="mt-1 flex-shrink-0 h-7 w-7 rounded-full bg-teal-50 border border-teal-200 flex items-center justify-center">
                  <svg
                    className="h-3.5 w-3.5 text-teal-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 4v16m8-8H4"
                    />
                  </svg>
                </div>

                {/* Content */}
                <div className="flex-1">
                  {/* Title */}
                  <p className="font-semibold text-sm capitalize">
                    {event.title}
                  </p>

                  {/* Changes as badges */}
                  {event.eventData?.changes?.length > 0 && (
                    <div className="flex flex-wrap gap-1.5 mt-1.5">
                      {event.eventData.changes.map((change, i) => (
                        <span
                          key={i}
                          className="inline-flex items-center text-xs px-2 py-0.5 rounded border border-blue-200 bg-blue-50 text-blue-700"
                        >
                          {change.field
                            .replace(/_/g, " ")
                            .replace(/\b\w/g, (c) => c.toUpperCase())}
                        </span>
                      ))}
                    </div>
                  )}

                  {/* User and date */}
                  <p className="text-xs text-muted-foreground mt-1.5">
                    {event.data?.lastModifiedUserRemoteName ?? event.user?.name} · {event.date}
                  </p>
                </div>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}